import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
import type { FacilityType } from '@/app/_lib/parseFacilities';
import { FacilityIcon, getFacilityTypeDescription, getFacilityTypeLabel } from './FacilityIcons';
const facilityTypes: FacilityType[] = ['corporate', 'adult-residential', 'elderly-residential'];
export function FacilityLegend() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="mb-4 text-center text-lg font-semibold text-gray-900 dark:text-gray-100">Facility Types</h3>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-4 rounded-lg bg-gray-50 px-0 py-5 md:px-6 md:py-6 dark:bg-gray-800">{t0}<div className="grid gap-4 md:grid-cols-3 md:gap-5">{facilityTypes.map(_temp)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(type) {
  return <div key={type} className={twMerge("$border-l-[6px] rounded-lg border border-t border-r border-b border-t-gray-200 border-r-gray-200 border-b-gray-200 bg-white p-3 dark:border-t-gray-600 dark:border-r-gray-600 dark:border-b-gray-600 dark:bg-gray-700", type === "corporate" && "border-l-indigo-600 hover:border-indigo-600 dark:hover:border-indigo-500", type === "adult-residential" && "border-l-teal-500 hover:border-teal-500 dark:hover:border-teal-400", type === "elderly-residential" && "border-l-amber-400 hover:border-amber-400 dark:hover:border-amber-300", !["corporate", "adult-residential", "elderly-residential"].includes(type) && "border-l-gray-300 hover:border-gray-400 dark:hover:border-gray-500")}><div className="flex items-start space-x-3"><div className="mt-1 flex-shrink-0"><FacilityIcon type={type} className="h-6 w-6" /></div><div className="flex-1"><h4 className="text-sm font-medium text-gray-900 dark:text-gray-100">{getFacilityTypeLabel(type)}</h4><p className="mt-1 text-xs text-gray-600 dark:text-gray-400">{getFacilityTypeDescription(type)}</p></div></div></div>;
}